export default "__VITE_ASSET__oXlHluBZ__"